import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaBriefcase, FaFileCircleCheck } from "react-icons/fa6";
import "./DashboardCom.css";
import logo from "/images/logo.png";

const Sidebar = ({ openSidebarToggle, OpenSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isDashboardActive =
    location.pathname === "/dashboard" || location.pathname === "/dashboard/profile";
  const application = location.pathname === "/dashboard/application";
  const asset = location.pathname === "/dashboard/asset";

  const handleClick = (e, path) => {
    e.preventDefault(); // Stop full-page reload
    navigate(path);     // Navigate using React Router

    if (window.innerWidth <= 768) {
      setTimeout(() => {
        OpenSidebar(false);
      }, 50);
    }
  };

  return (
    <aside
      id="sidebar"
      className={openSidebarToggle ? "sidebar-responsive" : ""}
    >
      <div className="sidebar-title">
        <div className="sidebar-brand">
          <div className="logo">
            <a href="/" onClick={(e) => handleClick(e, "/")}>
              <img src={logo} alt="Logo" />
            </a>
          </div>
        </div>
        <span
          className="icon close_icon mb-5"
          onClick={() => OpenSidebar(false)}
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          ✕
        </span>
      </div>

      <ul className="sidebar-list">
        <li className={`sidebar-list-item ${isDashboardActive ? "active" : ""}`}>
          <Link
            to="/dashboard"
            onClick={() => {
              if (window.innerWidth <= 768) {
                setTimeout(() => OpenSidebar(false), 100);
              }
            }}
          >
            <MdDashboard className="icon" />
            Dashboard
          </Link>
        </li>
        <li className={`sidebar-list-item ${application ? "active" : ""}`}>
          <Link
            to="/dashboard/application"
            onClick={() => {
              if (window.innerWidth <= 768) {
                setTimeout(() => OpenSidebar(false), 100);
              }
            }}
          >
            <FaFileCircleCheck className="icon" />
            Application
          </Link>
        </li>

        <li className={`sidebar-list-item ${asset ? "active" : ""}`}>
          <Link
            to="/dashboard/asset"
            onClick={() => {
              if (window.innerWidth <= 768) {
                setTimeout(() => OpenSidebar(false), 100);
              }
            }}
          >
            <FaFileCircleCheck className="icon" />
            Assets
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
